import type { FiltersWidgetStateParams } from '@repo/go-widgets/filters';

export function parseFiltersWidgetInternalState(state: object): {
  stateParams: FiltersWidgetStateParams;
} {
  let stateParams: FiltersWidgetStateParams = {};

  if ('stateParams' in state && typeof state.stateParams === 'object' && state.stateParams) {
    stateParams = state.stateParams as FiltersWidgetStateParams;
  }

  return {
    stateParams,
  };
}
